import { TextField } from "@material-ui/core";
import SingleSelectField from "@saleor/components/SingleSelectField";
import { OrderVerticalType } from "@saleor/types/globalTypes";
import * as React from "react";

import { LateDeliveryList } from "../initialData";

interface LateDeliveryProps {
  lateDeliveryReason: { value: string; otherReason: string };
  setLateDeliveryReason: (reason: {
    value: string;
    otherReason: string;
  }) => void;
  verticalType: OrderVerticalType;
}

const LateDelivery: React.FC<LateDeliveryProps> = props => {
  const { lateDeliveryReason, setLateDeliveryReason, verticalType } = props;

  const handleOnChange = (value: string) => {
    setLateDeliveryReason({
      otherReason: "",
      value
    });
  };

  const handleOnChangeOtherReason = (otherReason: string) => {
    setLateDeliveryReason({
      otherReason,
      value: "OTHERS"
    });
  };

  const getSelectValue = value => {
    if (!LateDeliveryList.find(e => e.value === value)) {
      return "OTHERS";
    } else {
      return value;
    }
  };

  return (
    <>
      <h3
        id="txtAdminFulfillmentAssignRiderDialogRiderReasonForLateDelivery"
        style={{
          margin: "0px",
          marginBottom: "6px",
          marginLeft: "5px"
        }}
      >
        <span>{"Rider Reason for Late Delivery"}</span>
      </h3>
      <SingleSelectField
        choices={LateDeliveryList.filter(e => e.type.includes(verticalType))}
        onChange={e => handleOnChange(e.target.value)}
        value={getSelectValue(lateDeliveryReason.value)}
        label={"Select Delivery Reason"}
        name="dropdownAdminFulfillmentAssignRiderDialogSelectFieldLateDelivery"
      />
      {lateDeliveryReason.value === "OTHERS" ||
      !LateDeliveryList.find(e => e.value === lateDeliveryReason.value) ? (
        <TextField
          id="txtAdminFulfillmentAssignRiderDialogRiderLateDeliveryReason"
          style={{
            marginTop: "2px"
          }}
          label="Specify other reason here"
          multiline
          fullWidth
          onChange={e => handleOnChangeOtherReason(e.target.value)}
          value={lateDeliveryReason.otherReason}
          rows={6}
        />
      ) : null}
    </>
  );
};

export default LateDelivery;
